import * as React from 'react';
import withClickOutsideOnOverlay from '../../../../../hoc/withClickOutsideOnOverlay';
import BasicFormWithValidation from '../../../../forms/BasicFormWithValidation';
import {FormWithCancelButton} from '../../../../forms/FormWithCancelButton';
import messages from '../../../../../const/messages';

const allowedOrganizationNameChars = '.:\\(\\)-\\s_';

type AddEditOrganizationNameFormProps = {
    organizationName: string;
    okAction: (email) => void;
}

class AddEditOrganizationNameForm extends FormWithCancelButton<AddEditOrganizationNameFormProps> {

    validateOrganizationName = ({ organizationName }) => {
        var regex = new RegExp(`^[a-zA-Z0-9${allowedOrganizationNameChars}]+$`);
        return !regex.test(organizationName) || !/^[\000-\177]*$/.test(organizationName) ? messages.organizationNameNotAllowedSymbols : null;
    }

    ok = ({ organizationName }) => {
        const { onClose, okAction } = this.props;
        onClose();
        okAction(organizationName);
    }

    cancel = () => {
        const { onClose } = this.props;
        onClose();
    }

    render() {
        const { organizationName } = this.props;
        return <BasicFormWithValidation
            title={`${organizationName ? 'Raname' : 'Add'} Organization`}
            type={`${organizationName ? 'rename' : 'add'}`}
            hasCloseIcon={true}
            inputs={[{
                name: 'organizationName',
                label: 'Organization',
                autoComplete: "off",
                autoFocus: true,
                maxLength: 50,
                maxLengthMsg: `Max organization name length: 50 characters`,
                value: organizationName || '',
                rules: [this.validateOrganizationName],
                applyOnEnter: true
            }]}
            okButton={{
                label: organizationName ? 'Rename' : 'Add',
                action: this.ok
            }}
            cancelButton={{
                label: 'Cancel',
                action: this.cancel,
            }}
        />;
    }
}

export default withClickOutsideOnOverlay(AddEditOrganizationNameForm);